<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 着工・出荷入力 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'状態'" :value="'XXXX'" />
						<ShowDetailRecord :columnName="'工事名'" :value="'XXXX'" />
						<ShowDetailRecord :columnName="'受注先'" :value="'XXXX'" />
						<ShowDetailRecord :columnName="'プラントメーカー'" :value="'XXXX'" />
						<ShowDetailRecord :columnName="'施工場所'" :value="'XXXX'" />
						<ShowDetailRecord :columnName="'品名'" :value="'XXXX'" />
					</tbody>
				</table>
				<v-form ref="form" v-model="valid">
					<table width="100%" class="show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord :columnName="'着工日'">
								<template v-slot:value>
									<v-menu
										close-on-content-click
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="TODO"
												background-color="white"
												outlined
												dense
												readonly
												hide-details
												v-bind="attrs"
												v-on="on"
											/>
										</template>
										<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
									</v-menu>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'出荷日'">
								<template v-slot:value>
									<v-menu
										close-on-content-click
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="TODO"
												background-color="white"
												outlined
												dense
												readonly
												hide-details
												v-bind="attrs"
												v-on="on"
											/>
										</template>
										<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
									</v-menu>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-form>
				<v-row no-gutters justify="center" class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col class="text-center" sm="6" cols="12">
						<v-btn color="secondary" @click="submitForm">
							<v-icon class="mr-1">mdi-content-save-outline</v-icon>
							保存する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" v-if="!$vuetify.breakpoint.xs" class="text-right">
						<v-btn class="ml-auto" text @click="showDialog = false"> キャンセル </v-btn>
					</v-col>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		construction: {
			// TODO:モデル名に合わせて名前は変更する
			type: Object,
			default: () => {
				return {}
			},
		},
		dialog: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			TODO: "",
			valid: false,
			rules,
			common,
		}
	},
	methods: {
		submitForm() {
			// TODO:
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$emit("update-construction", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
